import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { MachineType } from '../../interfaces/Brand.interfaces';

interface IOpenSmsWithPokeInfo {
  suggestedPrice: string;
  productId: string;
  productOwnerPhoneNumber: string;
  machineType: MachineType;
}

const makeSmsBody = (pokeInfo: IOpenSmsWithPokeInfo): string => {
  const serviceUrl = process.env.REACT_APP_CLIENT_URL;
  const utm = 'utm_source=DM%26utm_medium=sms%26utm_campaign=u2u_price_suggest%26utm_term=20250901';

  const body = `판매자님, 플루바 마켓에서 매물 잘 보았습니다.
${pokeInfo.suggestedPrice}원에 구매를 희망하는데 협의가 가능할까요?

클릭하여 내 매물 보기 : ${serviceUrl}${pageInfo.openMarketDetailPage.path}/${pokeInfo.productId}?machineType=${pokeInfo.machineType}%26${utm}`;

  return body;
};

export const openSmsWithPokeInfo = (pokeInfo: IOpenSmsWithPokeInfo) => {
  if (pokeInfo.productOwnerPhoneNumber) {
    const smsBody = makeSmsBody(pokeInfo);

    // UTM 파라미터가 제대로 전달되도록 SMS 링크 구성
    const smsLink = `sms:${pokeInfo.productOwnerPhoneNumber}?body=${encodeURIComponent(smsBody)}`;
    window.location.href = smsLink;
  }
};
